var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "transfer" },
    [
      _c("popup", {
        staticClass: "popup",
        attrs: { opened: _vm.openData, "use-header": true, "use-footer": true },
        on: {
          "update:opened": function($event) {
            _vm.openData = $event
          },
          cancel: _vm.popupClose
        },
        scopedSlots: _vm._u([
          {
            key: "subtitle",
            fn: function() {
              return [
                _c("h2", [
                  _vm._v(_vm._s(/*거래내역*/ _vm.$t("PCOP-02-02-04-19")))
                ])
              ]
            },
            proxy: true
          },
          {
            key: "content",
            fn: function() {
              return [
                [
                  _c("dl", { staticClass: "dlist dlist-item--type4" }, [
                    _c("dt", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(/*급여이체 관리번호*/ _vm.$t("MCOM-0000203"))
                        )
                      )
                    ]),
                    _c("dd", [_vm._v(_vm._s(_vm.detailInfo.salryTrsaccMgtNo))]),
                    _c("dt", [
                      _vm._v(
                        _vm._s(_vm.$t(/*출금계좌번호*/ "PCOP-02-03-03-06"))
                      )
                    ]),
                    _c("dd", [_vm._v(_vm._s(_vm.detailInfo.drwotAcno))]),
                    _c("dt", [
                      _vm._v(_vm._s(/*총 이체금액*/ _vm.$t("MCOM-0000201")))
                    ]),
                    _c("dd", [
                      _vm._v(
                        " MMK " +
                          _vm._s(
                            _vm.$num(
                              _vm._.map(
                                _vm.detailInfo.outItem.gridDtail,
                                function(v) {
                                  var trsaccAmt = v.trsaccAmt
                                  return trsaccAmt
                                }
                              ).reduce(function(a, b) {
                                return a + b
                              }, 0)
                            )
                          ) +
                          " "
                      )
                    ]),
                    _c("dt", [
                      _vm._v(_vm._s(/*총 이체 수수료*/ _vm.$t("MCOM-0000202")))
                    ]),
                    _c("dd", [
                      _vm._v(
                        " MMK " +
                          _vm._s(
                            _vm.$num(
                              _vm._.map(
                                _vm.detailInfo.outItem.gridDtail,
                                function(v) {
                                  var feeAmt = v.feeAmt
                                  return feeAmt
                                }
                              ).reduce(function(a, b) {
                                return a + b
                              }, 0)
                            )
                          ) +
                          " "
                      )
                    ]),
                    _c("dt", [
                      _vm._v(_vm._s(/*총 건수*/ _vm.$t("MCOM-0000200")))
                    ]),
                    _c("dd", [
                      _vm._v(
                        _vm._s(
                          _vm.$num(_vm.detailInfo.outItem.totalInquryCnt1, 0)
                        )
                      )
                    ]),
                    _c("dt", [
                      _vm._v(_vm._s(/*등록일*/ _vm.$t("PCOP-02-03-05-26")))
                    ]),
                    _c("dd", [
                      _vm._v(
                        _vm._s(_vm.$getGlobalDateFmt(_vm.detailInfo.regiYMS))
                      )
                    ]),
                    _c("dt", [
                      _vm._v(_vm._s(/*이체일*/ _vm.$t("MCOM-0000204")))
                    ]),
                    _c("dd", [
                      _vm._v(
                        _vm._s(
                          _vm.$getGlobalDateFmt(_vm.detailInfo.salryTrsaccYmd)
                        )
                      )
                    ])
                  ]),
                  _vm._l(_vm.detailInfo.outItem.gridDtail, function(
                    list,
                    index
                  ) {
                    return [
                      _c(
                        "div",
                        { key: index, staticClass: "box-white -type4" },
                        [
                          _c("div", { staticClass: "header" }, [
                            _c(
                              "div",
                              { staticClass: "title" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(list.mnrcvAcno) +
                                    "(" +
                                    _vm._s(list.cncycd) +
                                    ") "
                                ),
                                [
                                  "0|1|2|4".includes(
                                    list.brncoSalryTranStusDstcd
                                  )
                                    ? _c(
                                        "div",
                                        { staticClass: "state normal" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  list.brncoSalryTranStusDstcd +
                                                    "_mmrSalary"
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    : "3|9".includes(
                                        list.brncoSalryTranStusDstcd
                                      )
                                    ? _c(
                                        "div",
                                        { staticClass: "state warning" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  list.brncoSalryTranStusDstcd +
                                                    "_mmrSalary"
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _c("div", { staticClass: "desc" }, [
                                    _c("div", [
                                      _vm._v(
                                        "(" +
                                          _vm._s(
                                            list.tranStusCtnt == ""
                                              ? "-"
                                              : list.tranStusCtnt
                                          ) +
                                          ")"
                                      )
                                    ])
                                  ])
                                ]
                              ],
                              2
                            ),
                            _c("div", { staticClass: "desc" }, [
                              _c("div", { staticClass: "item account" }, [
                                _vm._v(_vm._s(list.trsaccDraweName))
                              ])
                            ])
                          ]),
                          _c("div", { staticClass: "content" }, [
                            _c("div", { staticClass: "account-info -type3" }, [
                              _c("div", { staticClass: "item sub" }, [
                                _c("div", { staticClass: "cont" }, [
                                  _c("span", { staticClass: "tit" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(/*은행명*/ "PCOP-02-03-03-11")
                                      )
                                    )
                                  ]),
                                  _c("span", { staticClass: "dec" }, [
                                    _vm._v(_vm._s(list.bnkName))
                                  ])
                                ]),
                                _c("div", { staticClass: "cont" }, [
                                  _c("span", { staticClass: "tit" }, [
                                    _vm._v(
                                      _vm._s(
                                        /*이체금액*/ _vm.$t("PCOP-02-03-03-12")
                                      )
                                    )
                                  ]),
                                  _c("span", { staticClass: "dec" }, [
                                    _vm._v(
                                      _vm._s(list.cncycd) +
                                        " " +
                                        _vm._s(_vm.$num(list.trsaccAmt))
                                    )
                                  ])
                                ]),
                                _c("div", { staticClass: "cont" }, [
                                  _c("span", { staticClass: "tit" }, [
                                    _vm._v(
                                      _vm._s(
                                        /*수수료*/ _vm.$t("PCOP-02-03-03-13")
                                      )
                                    )
                                  ]),
                                  list.feeAmt != null
                                    ? _c("span", { staticClass: "dec" }, [
                                        _vm._v(
                                          _vm._s(list.cncycd) +
                                            " " +
                                            _vm._s(_vm.$num(list.feeAmt))
                                        )
                                      ])
                                    : _c("span", { staticClass: "dec" }, [
                                        _vm._v(
                                          _vm._s(list.cncycd) +
                                            " " +
                                            _vm._s(_vm.$num(0))
                                        )
                                      ])
                                ]),
                                _c("div", { staticClass: "cont" }, [
                                  _c("span", { staticClass: "tit" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          /*비고*/ _vm.$t("MPAY-02-01-25-13")
                                        )
                                      )
                                    )
                                  ]),
                                  _c("span", { staticClass: "dec" }, [
                                    _vm._v(_vm._s(list.inotBasiSumryCtnt))
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]
                      )
                    ]
                  })
                ]
              ]
            },
            proxy: true
          },
          {
            key: "footer",
            fn: function() {
              return [
                _c(
                  "button",
                  {
                    staticClass: "btn bottom positive",
                    on: {
                      click: function($event) {
                        return _vm.popupClose()
                      }
                    }
                  },
                  [_vm._v(_vm._s(/*확인*/ _vm.$t("MPAY-04-01-10-21")))]
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }